export default "__VITE_ASSET__DiDQTJn9__"